<template>
    <div>
        <strong>TOTAL SUBMISSIONS: </strong>{{ totalSubmissions }}<br>
        <strong>PAGES: </strong>
        <a v-if="previousPageLink" v-on:click="changePage(previousPageLink)" style="text-decoration:none;"><span class="icon-arrow-left">< </span></a> 
            {{ currPage }} of {{ totalPages }}
        <a v-if="nextPageLink" v-on:click="changePage(nextPageLink)" style="text-decoration:none;"><span class="icon-arrow-right"> ></span></a>
    </div>
</template>

<script>
export default {
    props: ['totalSubmissions', 'previousPageLink', 'nextPageLink', 'currPage', 'totalPages'],
    methods: {
        changePage(link) {
            this.$emit('change-page', link);
        }
    }
}
</script>

<style scoped>
    .icon-arrow-left {
        content: "\e906";
        cursor: pointer;
    }

    .icon-arrow-right {
        content: "\e909";
        cursor: pointer;
    }
</style>